import React from 'react';
import LayoutOne from '../../layouts/LayoutOne';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

const ThankYouPage = () => {
  const navigate = useNavigate()
  const location = useLocation() 
  const orderId = location?.state?.orderId || 'N/A'
  const handleNavigate = (value) => {
    navigate(value)
  }
  return (
    <LayoutOne>
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col
            xs={12}
            md={6}
            className="d-flex flex-column justify-content-center align-items-center text-center p-5"
            style={{
              backgroundColor: '#fff',
              minHeight: '100vh'
            }}
          >
            <h2 className="text-primary fw-bold mb-4">
              Thank You For Your Purchase !
            </h2>
            <p className="text-muted mb-5">
              your order number  <strong>#{orderId}</strong>, you will receive a confirmation email shortly.
            </p>
            <div>
              <Button variant="primary" className="me-3 px-4 py-2" onClick={() => handleNavigate("/")}>
                CONTINUE TO HOMEPAGE
              </Button>
              <Button variant="outline-secondary" className="px-4 py-2" onClick={() => handleNavigate("/orders")}>
                VIEW MY ORDER
              </Button>
            </div>
          </Col>

          {/* Right Section - Image */}
          <Col
            xs={12}
            md={6}
            className="d-none d-md-block"
            style={{
              backgroundImage: 'url("/assets/img/svg/main.jpg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
          </Col>
        </Row>
      </Container>
    </LayoutOne>
  );
};

export default ThankYouPage;